module.exports = __webpack_public_path__ + "img/settings-02.6fcf0df4.svg";